import React, { Component } from "react";
import {
  Layout,
  Button,
  Icon,
  Carousel,
  Anchor,
  Tag,
  Menu,
  Dropdown,
} from "antd";
import { withTranslation } from "react-i18next";
import "./index.css";
import bg from '../../../assets/images/itPro/bg.png'
import wordBar from '../../../assets/images/itPro/section02.png'
import pic1 from '../../../assets/images/itPro/pic1.png'
import pic2 from '../../../assets/images/itPro/pic2.png'
import pic2_tw from '../../../assets/images/itPro/pic2_tw.png'
import i18n from "i18next";
const { Link } = Anchor;
const { Content } = Layout;
let url = window.location.host;
//let dlLocation = 'http://es-ygj.digiwincloud.com.cn'//大陆
let twLocation = "es-ygj.digiwincloud.com"; //台湾
let iTCloudStr=''
class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  componentDidMount() {
    if (url === twLocation) {
      //台湾
      iTCloudStr=this.props.t('ITCloud_TW');
    } else {
      //大陆
      iTCloudStr=this.props.t('ITCloud_CN');
    }
  }
  render() {
    const { t } = this.props;
    const img2=window.location.hostname==='es-ygj.digiwincloud.com' || i18n.language!='zhCN'? pic2_tw: pic2
    return (
      <Content className="q-content-wrapper">
        <div className="q-pro-bg"><img style={{width: '100%'}}  src={bg} />
        <div className="i-detail-pro">
          <div className="i-left">
            <h1>{iTCloudStr}</h1>
            <p><img src={wordBar} /></p>
            <ul> 
              <li>{t('message01')}</li>
              <li>{t('message02')}</li>
              <li>{t('message03')}</li>
            </ul>
            {/* <Button>立即适用</Button> */}
          </div>
          <div className="i-right">
          <img src={pic1} />
          </div>
          </div>
        </div>
        <div className="q-main" style={{ padding: "25px" , textAlign:'center'}}>
          <div style={{marginBottom:'50px'}}>
          <img src={img2} />
          </div>
          <div className="q-product-content">
            <div className="i-left-p">
            <div className="i-border">
              <h2>{t('message04')}</h2>
              <p style={{textAlign:'left'}}>{t('message05')}</p>
              </div>
            </div>
            <div className="i-right-p">
            <div className="i-border">
              <h2>{t('message06')}</h2>
              <p style={{textAlign:'left'}}>{t('message07')}</p>
              </div>
            </div>
          </div>
        </div>
      </Content>
    );
  }
}
export default withTranslation()(NotFound);
